import { render, staticRenderFns } from "./section-video-empresa.vue?vue&type=template&id=1cfc92aa&scoped=true"
import script from "./section-video-empresa.vue?vue&type=script&lang=js"
export * from "./section-video-empresa.vue?vue&type=script&lang=js"
import style0 from "./section-video-empresa.vue?vue&type=style&index=0&id=1cfc92aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfc92aa",
  null
  
)

export default component.exports